import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import TrashIcon from "../assets/icon/TrashIcon";
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import axios from 'axios';
import styled from 'styled-components';
import { Alert, Button, Container, CssBaseline, FormHelperText, Grid, InputAdornment, Pagination, Snackbar, SnackbarContent, TextField, Typography } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import AdminNavigation from './adminNavigation';
import { btnStyleContrast, btnStyleOutlined, lightergrayHex, headerStyleContrast, textExtraSmallStyleContrast, textStyleContrast } from '../helper/style';
import InventoryService from '../services/manager/inventoryService';
import LiqueModal from '../customer/components/liqueModal';

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default function ReviewStok() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const cleanedBackendUrl = backendUrl.replace("/backend", "");
  const [rows, setRows] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [msgSuccess, setmsgSuccess] = useState('');
  const [showError, setShowError] = useState(false);
  const [msgError, setMsgError] = useState();
  const [nama, setnama] = useState('');
  const [varian, setvarian] = useState('');
  const [weight, setweight] = useState('');
  const [kodeBarang, setKodeBarang] = useState("");
  const [errors, setErrors] = useState({});
  const [openTambah, setOpenTambah] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenTambah = () => setOpenTambah(true);
  const [updatedId, setUpdatedId] = useState('');
  const handleCloseDelete = () => setOpenDelete(false);

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalItem, setTotalItem] = useState(0);
  const [totalPage, setTotalPage] = useState(1);

  const validate = () => {
    let tempErrors = {};

    // Validasi Kode Barang
    if (!kodeBarang) {
      tempErrors.kodeBarang = "Kode barang harus diisi";
    } else if (kodeBarang.length > 3) {
      tempErrors.kodeBarang = "Kode barang maksimal 3 karakter";
    }

  // Validasi Nama
  if (!nama) {
    tempErrors.nama = 'Jenis barang harus diisi';
  } else if (nama.length > 255){
    tempErrors.nama = 'Jenis barang maksimal 255 karakter'
  }

  // Validasi Varian
  if (!varian) {
    tempErrors.varian = 'varian barang harus diisi';
  } else if (varian.length > 255){
    tempErrors.varian = 'varian barang maksimal 255 karakter'
  }

  // Validasi Weight
  if (!weight) {
    tempErrors.weight = 'Berat barang harus diisi';
  } else if (weight.length > 10) { // contoh panjang maksimal 10 karakter
    tempErrors.weight = 'Berat barang maksimal 10 karakter';
  }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const fetchDataInventori = async () => {
    try {
      const response = await InventoryService.fetchDataItemTypesPageable(page, perPage, search);
      if (response) {
        const data = response.data;

        setRows(data.itemTypeList);
        setTotalItem(data.totalData);
        setTotalPage(data.totalPage);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchDataInventori();
  }, []);

  const handleCloseTambah = () => {
    setOpenTambah(false);
    setErrors({});
    setnama('');
    setvarian('');
    setweight('');
    setKodeBarang('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        const response = await axios.post(`${cleanedBackendUrl}/items/types`, {
          code: kodeBarang,
          name: nama,
          variant: varian,
          weight: weight,
        });
        console.log(response.data);
        setOpenTambah(false);
        setShowSuccess(true);
        setmsgSuccess("Berhasil Menambah Tipe Barang");
        setTimeout(() => {
          setShowSuccess(false);
        }, 5000);
        fetchDataInventori();
        setnama('');
        setvarian('');
        setweight('');
        setKodeBarang('');
      } catch (error) {
        setErrors(error.response);
        setShowError(true);
        setMsgError("Gagal Menambah Tipe Barang");
        setTimeout(() => {
          setShowError(false);
        }, 5000);
      }
    } else {
      console.log("Validation failed");
    }
  };

  const handleOpenEdit = (row) => {
    setUpdatedId(row.id);
    setnama(row.name);
    setvarian(row.variant);
    setweight(row.weight);
    setKodeBarang(row.code);
    setOpenEdit(true);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
    setErrors({});
    setnama('');
    setvarian('');
    setweight('');
  };

  const handleConfirmEdit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const id = updatedId;
      try {
        // const response = await axios.post(`${backendUrl}/admin/editTipe`, { id, nama, varian, weight });
        const response = await axios.put(
          `${cleanedBackendUrl}/items/types/${id}`,
          {
            id: id,
            code: kodeBarang,
            name: nama,
            variant: varian,
            weight: weight,
          }
        );
        console.log(response.data);
        setShowSuccess(true);
        setmsgSuccess("Berhasil Mengubah Tipe Barang");
        setTimeout(() => {
          setShowSuccess(false);
        }, 5000);
        fetchDataInventori();
        setnama("");
        setvarian("");
        setweight("");
        setKodeBarang("");
      } catch (error) {
        setShowError(true);
        setMsgError("Gagal Mengubah Tipe Barang");
        setTimeout(() => {
          setShowError(false);
        }, 5000);
      }
      setOpenEdit(false);
    } else {
      console.log("Validation failed");
    }
  };

  const handleOpenDelete = (row) => {
    setUpdatedId(row.id);
    console.log(row.id)
    setOpenDelete(true);
  };

  const handleConfirmDelete = async (e) => {
    e.preventDefault();
    try {
      const id = updatedId;
      const response = await axios.delete(
        `${cleanedBackendUrl}/items/types/${id}`
      );
      console.log(response.data);
      setShowSuccess(true);
      setmsgSuccess("Berhasil Hapus Tipe Barang");
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
      fetchDataInventori();
    } catch (error) {
      console.error(error);
      if (error.response.status === 422) {
        setMsgError("Gagal Hapus Tipe Barang, Tipe masih dipakai oleh beberapa stok");
      } else {
        setMsgError("Gagal Hapus Tipe Barang");
      }
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 5000);
    }
    setOpenDelete(false);
  };

  const searchTimeout = useRef(null);
  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      setPage(1);
      fetchDataInventori()
    }, 500);
    return () => clearTimeout(searchTimeout.current);
  }, [search]);

  useEffect(() => {
    fetchDataInventori();
    window.scrollTo(0, 0);
  }, [page]);

  return (
    <Box>
      <CssBaseline />
      <AdminNavigation />
      <Container
        component="main"
        maxWidth="xl"
      >
        <RootContainer>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={showSuccess}
            autoHideDuration={3000}
            onClose={() => setShowSuccess(false)}
          >
            <SnackbarContent
              sx={{ backgroundColor: "#19B600" }} 
              message={msgSuccess}/>
          </Snackbar>
    
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={showError}
            autoHideDuration={3000}
            onClose={() => setShowError(false)}
          >
            <SnackbarContent 
              sx={{ backgroundColor: "#E50B0B" }} 
              message={msgError}/>
          </Snackbar>

          <Grid container spacing={1} alignItems="center" marginBottom={2}>
            <Grid item xs={12} md={6}>
              <Typography sx={{ ...headerStyleContrast }}>
                Kelola SKU
              </Typography>
            </Grid>
            <Grid item xs={6} sm={8} md={4}>
              <TextField
                fullWidth
                value={search}
                placeholder="Cari SKU..."
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{ 
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchOutlinedIcon />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={2}>
              <Button 
                endIcon={<AddIcon sx={{ color: "white" }} />}
                style={{ ...btnStyleContrast, borderRadius: "50px", width: "100%" }} 
                onClick={handleOpenTambah}>
                Tambah SKU
              </Button>
            </Grid>
          </Grid>

          <Box sx={{ marginTop: "20px", width: "100%" }} marginBottom={3}>
            {
              rows.map(type => (
                <Box  
                  key={type.id}
                  sx={{ background: "white", borderRadius: "16px", padding: "16px", marginBottom: "20px", boxShadow: "2px 2px 10px rgba(0, 0, 0, .2)" }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} display="flex" gap="20px" alignItems="center">
                      <Typography sx={{ ...textStyleContrast, color: lightergrayHex }} display="flex" alignItems="center" gap="10px">
                        <CalendarTodayOutlinedIcon /> <span>Last Update: {type.lastUpdate}</span>
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography sx={{ ...textStyleContrast, fontWeight: "500" }}>
                        {type.variant}
                      </Typography>
                      <Typography sx={{ ...textExtraSmallStyleContrast }}>
                        {type.code} • {type.name} • {type.weight}g
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} display="flex" justifyContent="end" gap="10px">
                      <Button 
                        sx={{ ...btnStyleContrast, borderRadius: "50px", width: "120px" }}
                        endIcon={<EditOutlinedIcon />}
                        onClick={() => handleOpenEdit(type)}
                      >
                        Edit
                      </Button>
                      <Button 
                        sx={{ ...btnStyleOutlined, borderRadius: "50px", width: "120px", color: "red", border: "1px solid red" }}
                        endIcon={<TrashIcon color="red" />}
                        onClick={() => handleOpenDelete(type)}
                      >
                        Delete
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              ))
            }

            <Box display="flex" justifyContent="center">
              <Pagination sx={{ 
                  '& .MuiPaginationItem-root': {
                    color: 'black', 
                  },
                  '& .MuiPaginationItem-icon': {
                    color: 'black', 
                  },
                  '& .Mui-selected': {
                    backgroundColor: 'black !important', 
                    color: 'white', 
                  },
                }} 
                size="small"
                count={totalPage} 
                page={page}
                onChange={(_event, page) => setPage(page)} />
            </Box>  
          </Box>

          {/* ini modal edit data */}
          <LiqueModal open={openEdit} onClose={handleCloseEdit} width="750px">
            <form>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography>Kode Barang *</Typography>
                  <TextField
                    fullWidth
                    autoComplete="off"
                    value={kodeBarang}
                    error={!!errors.kodeBarang}
                    helperText={errors.kodeBarang}
                    FormHelperTextProps={{ sx: { color: "red" } }}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (input.length <= 3) {
                        setKodeBarang(input);
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography>Varian Barang *</Typography>
                  <TextField
                    fullWidth
                    autoComplete='off'
                    value={varian}
                    error={!!errors.varian}
                    helperText={errors.varian}
                    FormHelperTextProps={{ sx: { color: 'red' } }}
                    onChange={(e) => setvarian(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography>Jenis Barang *</Typography>
                  <TextField
                    fullWidth
                    autoComplete='off'
                    value={nama}
                    error={!!errors.nama}
                    helperText={errors.nama}
                    FormHelperTextProps={{ sx: { color: 'red' } }}
                    onChange={(e) => setnama(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography>Berat Barang *</Typography>
                  <NumericFormat
                    fullWidth
                    autoComplete='off'
                    value={weight}
                    onValueChange={(values) => setweight(values.floatValue)}
                    thousandSeparator='.'
                    decimalSeparator=','
                    customInput={TextField}
                    error={!!errors.weight}
                    InputProps={{
                      endAdornment: <InputAdornment position="start">g</InputAdornment>,
                    }}
                    variant="outlined"
                  />
                  {!!errors.weight && (
                    <FormHelperText error sx={{ color: 'red' }}>
                      {errors.weight}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    onClick={handleConfirmEdit}
                    fullWidth
                    style={{ backgroundColor: "black", color: "white" }}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </form>
          </LiqueModal>

          {/* ini modal delete tipe */}
          <LiqueModal open={openDelete} onClose={handleCloseDelete} width="500px">
            <Box textAlign="center">
              <Typography
                id="spring-modal-title"
                variant="h6"
                component="h2"
              >
                Apakah kamu yakin ingin membuang data ini?
              </Typography>
              <Box sx={{ mt: 2 }}>
                <Button variant="outlined" onClick={handleCloseDelete}>
                  Tidak
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleConfirmDelete}
                  sx={{ ml: 2, backgroundColor: "red", color: "white" }}
                >
                  Buang
                </Button>
              </Box>
            </Box>
          </LiqueModal>

          {/* ini modal tambah tipe */}
          <LiqueModal open={openTambah} onClose={handleCloseTambah} width="750px">
            <form>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography>Kode Barang *</Typography>
                  <TextField
                    fullWidth
                    autoComplete="off"
                    value={kodeBarang}
                    error={!!errors.kodeBarang}
                    helperText={errors.kodeBarang}
                    FormHelperTextProps={{ sx: { color: "red" } }}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (input.length <= 3) {
                        setKodeBarang(input);
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography>Varian Barang *</Typography>
                  <TextField
                    fullWidth
                    autoComplete="off"
                    value={nama}
                    error={!!errors.nama}
                    helperText={errors.nama}
                    FormHelperTextProps={{ sx: { color: "red" } }}
                    onChange={(e) => setnama(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography>Jenis Barang *</Typography>
                  <TextField
                    fullWidth
                    autoComplete="off"
                    value={varian}
                    error={!!errors.varian}
                    helperText={errors.varian}
                    FormHelperTextProps={{ sx: { color: "red" } }}
                    onChange={(e) => setvarian(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography>Berat Barang *</Typography>
                  <NumericFormat
                    fullWidth
                    autoComplete="off"
                    value={weight}
                    onValueChange={(values) => setweight(values.floatValue)}
                    thousandSeparator="."
                    decimalSeparator=","
                    customInput={TextField}
                    error={!!errors.weight}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">g</InputAdornment>
                      ),
                    }}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    fullWidth
                    style={{ backgroundColor: "black", color: "white" }}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </form>
          </LiqueModal>
        </RootContainer>
      </Container>
    </Box>
  );
}
